import React from "react";
import Discover from "../Discover/Discover";
import ExclusiveProduct from "../ExclusiveProduct/ExclusiveProduct";
import Flooring from "../Flooring/Flooring";
import FlooringForBusiness from "../FlooringForBusiness/FlooringForBusiness";
import GoogleMap from "../GoogleMap/GoogleMap";
import OfferAndAppointment from "../OfferAndAppointment/OfferAndAppointment";
import SeeFloor from "../SeeFloor/SeeFloor";
import ShopHundreds from "../ShopHundreds/ShopHundreds";
import TopItems from "../TopItems/TopItems";

const Home = () => {
  return (
    <div className="bg-base-300">
      <OfferAndAppointment />
      <Discover />
<section className="py-12 bg-gray-100">
  <div className="max-w-6xl mx-auto px-4 text-center">
   

    <div className="flex justify-center">
      <video
        className="w-full max-w-sm md:max-w-md lg:max-w-lg rounded-2xl shadow-2xl"
        controls
        playsInline
        preload="metadata"
      >
        <source src="/static/media/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>

      <TopItems />
      <SeeFloor />
      <ExclusiveProduct />
      <ShopHundreds />
      <Flooring />
      <FlooringForBusiness />
      <GoogleMap />
    </div>
  );
};

export default Home;
